var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZilappLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 43,
    viewBox: "0 0 158 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.985 21.453C81.9848 17.663 79.007 14.6857 75.3217 14.6852C71.532 14.6852 68.4497 17.7667 68.4494 21.453C68.4494 25.1909 71.4794 28.2205 75.2172 28.2208C78.9552 28.2208 81.985 25.1911 81.985 21.453ZM90.5409 36.7766H81.985V35.2017C79.9437 36.2084 77.6472 36.7766 75.2172 36.7766C66.7542 36.7763 59.8937 29.9161 59.8937 21.453C59.894 12.9385 66.9104 6.12944 75.3217 6.12944C77.7235 6.12956 79.9811 6.67992 81.985 7.65845C87.2589 10.5319 90.5409 16.0576 90.5409 22.0634V36.7766Z",
    fill: "#FF6347"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.669 14.0171H43.2502V36.7766H34.669V14.0171Z",
    fill: "#FF6347"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3228 5.26851C44.3228 12.0781 33.5963 12.0781 33.5963 5.26851C33.5963 -1.54105 44.3228 -1.54106 44.3228 5.26851Z",
    fill: "#FF6347"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9442 0H47.75V36.7766H56.9442V0Z",
    fill: "#FF6347"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9391 28.2442L14.4642 28.3343L30.6472 0L5.70809 0.0992855C3.4019 0.0992855 1.53236 1.98917 1.53236 4.32047C1.53236 6.65176 3.4019 8.54165 5.70809 8.54165L16.183 8.44236L0 36.7766L24.9391 36.6866C27.2453 36.6866 29.1148 34.7967 29.1148 32.4654C29.1148 30.1341 27.2453 28.2442 24.9391 28.2442Z",
    fill: "#FF6347"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.709 6.08052C117.12 6.08052 124.137 12.9007 124.138 21.4296C124.138 29.9071 117.277 36.7798 108.814 36.7801C106.384 36.78 104.088 36.211 102.047 35.2028V42.8571H93.4904V22.0416C93.4904 13.6108 100.194 6.08131 108.709 6.08052ZM108.709 14.6507C105.024 14.6512 102.046 17.6334 102.046 21.4296C102.046 25.174 105.076 28.2099 108.814 28.2099C112.552 28.2096 115.581 25.1738 115.581 21.4296C115.58 17.7372 112.499 14.6507 108.709 14.6507Z",
    fill: "#FF6347"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.872 6.08052C150.283 6.08052 157.3 12.9007 157.3 21.4296C157.3 29.9071 150.44 36.7798 141.977 36.7801C139.547 36.78 137.251 36.211 135.21 35.2028V42.8571H126.653V22.0416C126.653 13.6108 133.357 6.08131 141.872 6.08052ZM141.872 14.6507C138.187 14.6511 135.209 17.6333 135.208 21.4296C135.208 25.1738 138.238 28.2096 141.975 28.2099C145.713 28.2097 148.744 25.1738 148.744 21.4296C148.743 17.7373 145.661 14.6509 141.872 14.6507Z",
    fill: "#FF6347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZilappLogo);
export default __webpack_public_path__ + "static/media/zilapp_logo.728e276b09549c4995f5f1ee6e715835.svg";
export { ForwardRef as ReactComponent };